import React from 'react';
import { Button, ButtonProps } from '@wix/design-system';
import { useToolbarCollectionContext } from '../ToolbarCollectionContext';
import { Add } from '@wix/wix-ui-icons-common';
import { useWixPatternsContainer } from '@wix/bex-core/react';

export type PrimaryActionButtonProps = Omit<
  ButtonProps,
  'priority' | 'size' | 'fullWidth' | 'dataHook' | 'skin' | 'as'
> & { onClick?: any };

export const PrimaryActionButton = (props: PrimaryActionButtonProps) => {
  const { translate: t } = useWixPatternsContainer();
  const { toolbarBIReporter } = useToolbarCollectionContext();

  return (
    <Button
      prefixIcon={<Add />}
      {...props}
      as="button"
      size="small"
      priority="primary"
      skin="standard"
      dataHook="toolbar-primary-action-button"
      onClick={(event) => {
        toolbarBIReporter.onPrimaryActionButtonClick();
        props.onClick?.(event);
      }}
    >
      {props.children ?? t('cairo.collectionsPage.add.item.CTA')}
    </Button>
  );
};

PrimaryActionButton.displayName = 'PrimaryActionButton';
